import React, { useState } from 'react';
import { answerChoices } from '../../../lib/evaluationIntegrity';
import { effectiveSectionWeight, weightSummary } from '../../../lib/templateIntegrity';

const REQUIREMENTS = [
  ['observation', 'Observación'],
  ['photo', 'Foto'],
  ['geo', 'Ubicación'],
  ['document', 'Documento'],
  ['recommendation', 'Recomendación'],
];

export function RequirementsEditor({ value = {}, onChange, disabled }) {
  return (
    <div className="space-y-2">
      <p className="soem-label">Requisitos</p>
      {REQUIREMENTS.map(([key, label]) => (
        <label key={key} className="block text-sm">
          {label}
          <select
            className="w-full border p-2"
            disabled={disabled}
            value={value[key] || 'never'}
            onChange={(event) => onChange({ ...value, [key]: event.target.value })}
          >
            <option value="never">Nunca</option>
            <option value="always">Siempre</option>
            <option value="below_standard">Solo si no cumple</option>
          </select>
          {key === 'geo' && <small>Se cumple con GPS o zona.</small>}
          {key === 'document' && <small>Requiere un PDF adjunto.</small>}
        </label>
      ))}
    </div>
  );
}

export function VisibilityEditor({ value, previousQuestions, onChange, disabled }) {
  const eligible = previousQuestions.filter((question) => answerChoices(question).length);
  const parent = eligible.find((question) => question.id === value?.question_id);
  const choices = parent ? answerChoices(parent) : [];
  const invalid = value?.question_id && !parent;
  function toggle(answer, checked) {
    const answers = checked
      ? [...(value.answers || []), answer]
      : value.answers.filter((entry) => entry !== answer);
    onChange({ ...value, answers });
  }
  return (
    <div className="space-y-2">
      <p className="soem-label">Mostrar solo si…</p>
      <select
        aria-label="Pregunta anterior"
        className="w-full border p-2"
        disabled={disabled}
        value={value?.question_id || ''}
        onChange={(event) =>
          onChange(event.target.value ? { question_id: event.target.value, answers: [] } : null)
        }
      >
        <option value="">Siempre visible</option>
        {invalid && <option value={value.question_id}>(pregunta no válida)</option>}
        {eligible.map((question) => (
          <option key={question.id} value={question.id}>
            {question.code || ''} {question.title}
          </option>
        ))}
      </select>
      {choices.map((answer) => (
        <label key={answer} className="block text-sm">
          <input
            type="checkbox"
            disabled={disabled}
            checked={value?.answers?.includes(answer) || false}
            onChange={(event) => toggle(answer, event.target.checked)}
          />{' '}
          {answer}
        </label>
      ))}
      {value && !value.answers?.length && (
        <p role="alert">Elige al menos una respuesta antes de guardar.</p>
      )}
    </div>
  );
}

export function SectionWeightEditor({ section, sections, onSave, disabled }) {
  const [value, setValue] = useState(section.weight ?? '');
  const effective = effectiveSectionWeight(section, sections);
  const { total, excluded } = weightSummary(sections);
  async function save() {
    const weight = value === '' ? null : Math.min(100, Math.max(0, Number(value)));
    const saved = await onSave(weight);
    if (saved === false) setValue(section.weight ?? '');
  }
  return (
    <div className="space-y-1 text-xs">
      <label>
        Peso (%)
        <input
          type="number"
          min="0"
          max="100"
          disabled={disabled}
          className="border p-1 w-20 ml-2"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onBlur={save}
        />
      </label>
      <p>
        Peso efectivo: {effective.toFixed(1)}% {section.weight == null ? '(automático: nombre o promedio de pesos efectivos)' : '(configurado; se completa si es cero)'}
      </p>
      <p>
        Suma efectiva: {total.toFixed(1)}% {total !== 100 && '· El motor renormaliza los pesos.'}
      </p>
      {excluded.includes(section.id) && (
        <p role="alert" className="text-red-700">
          Esta sección no cuenta en la calificación
        </p>
      )}
    </div>
  );
}
